import http from './../../../base/api/public'

let service = require('@/../config/serviceList')
let sysConfig = require('@/../config/sysConfig')
let apiPre = sysConfig.apiPre

export default {
    getPage(params) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/getPage', params)
    },
   getPartnerPage(params) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/getPartnerPage', params)
    },
    delete(params) {
        return http.requestPostKeyValue(apiPre + service.rbac + '/rbac/user/delete', params)
    },
    getDtoById(params) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/getDto/' + params, {})
    },
    insert(params) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/insert', params)
    },
   insertOfOperator(params) {
    return http.requestPost(apiPre + service.rbac + '/rbac/user/insertOfOperator', params)
   },
   updateOfOperator(params) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/updateOfOperator', params)
    },
   deleteOfOperator(params) {
    return http.requestPost(apiPre + service.rbac + '/rbac/user/deleteOfOperator', params)
   },
  getDtoOfOperator(params) {
    return http.requestPost(apiPre + service.rbac + '/rbac/user/getDtoOfOperator' , params)
  },
    getUser(params) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/getByUser', params)
    },
    findByUsernameOrMobile(param) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/findByUsernameOrMobile/' + param, {})
    },
    updatePersonalInfo(param) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/updatePersonalInfo', param)
    },
    getDetail(id) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/detail/' + id, {})
    }
}



// WEBPACK FOOTER //
// ./src/module/systemManagement/api/user.js